<template>

  <!-- 1st Hero Variation -->
  <section class="section section-shaped section-lg my-0" style="background: url(img/header_bg.jpg)!important;padding-bottom: 100px;">

    <card type="secondary" style="" shadow  v-if="is_load"
          header-classes="bg-white pb-5"
          body-classes=""
          class="border-0 funnel_card">
      <div class="row">

        <div class="col-lg-12 text-center lead_title" v-if="is_load==true">
          <h2><sui-button icon="arrow left" @click="returnBack()" /> Лид #{{lead.id}}</h2>
        </div>
        <div class="row col-lg-12" v-if="is_load==true">

        <div class="col-lg-3">
          <div  class="well" style="" shadow>
            <sui-card class="card_in_lead">
              <sui-card-content  class="lead_info">
                <sui-card-meta>

                  <div class="form-group">
                    <label>Воронка/Статус</label>
                    <select class="form-control" v-model="lead.status_id" @change="changeStatus">
                      <option   v-if="statuses.length>0" v-for="status in statuses" :value="status.last_id"
                              :key="status.last_id">{{status.funnel.title}}/{{
                          status.title
                        }}
                      </option>
                    </select>
                  </div>
                </sui-card-meta>

                <sui-card-meta>
                  <div class="form-group">
                    <vue-tags-input
                        v-model="tag"
                        :tags="tags"
                        @tags-changed="tagsChanged" placeholder="Введите новый тег"
                    />


                  </div>
                </sui-card-meta>

                <sui-card-meta>
                  <div class="form-group">
                    <label>Ответственный</label>
                    <select class="form-control" @change="changeResponsible" v-model="lead.responsible_id">
                      <option v-if="users.length>0" v-for="user in users" :value="user.last_id"
                              :key="user.last_id">{{
                          user.name
                        }}
                      </option>
                    </select>
                  </div>
                </sui-card-meta>


                <sui-card-meta>
                  <div class="form-group"  >
                    <label  >Разработчик(только логин) </label>

                    <input type="text"     class="form-control" v-model="lead.developer_username"
                    />
                  </div>
                </sui-card-meta>

              </sui-card-content>
              <sui-card-meta v-if="lead.user_id==null">
                <div class="form-group">
                  <label class="badge">Не верифицирован!</label>
                  <a :href="'https://telegram.me/artemdevrubot?start=confirm'+lead.secretId" target="_blank" class="btn side3">Ссылка на верификацию</a>
                </div>
              </sui-card-meta>
              <sui-card-meta v-if="lead.user_id!=null" class="ml-4 mt-4">
                <p>id {{ lead.client.telegram_id}}</p>
                <p v-if="lead.client.username">username <a :href="'https://t.me/'+lead.client.username" target="_blank">@{{lead.client.username}}</a></p>
              </sui-card-meta>
            </sui-card>
          </div>

          <sui-card class="card_in_lead">
            <sui-card-content class="lead_info">
              <sui-card-header>Основные данные</sui-card-header>


              <sui-card-meta>
          <div class="form-group">
            <label>Тип</label>
            <select class="form-control" v-model="lead.category_id">
              <option v-if="categorys.length>0" v-for="category in categorys" :value="category.last_id"
                      :key="category.last_id">{{
                  category.name
                }}
              </option>
            </select>
          </div>
              </sui-card-meta>

              <sui-card-meta v-if="lead.lead_data.length>0" v-for="(field,field_index) in lead.lead_data"
                             :key="field.last_id">
          <div class="form-group"  >
            <label  >{{ field.title}} </label>

            <input type="text" v-if="field.type=='string'"  class="form-control" v-model="lead.lead_data[field_index].value"
            />
            <input type="file" v-if="field.type=='image' || field.type=='file'"  class="form-control"
            />
            <input type="number" v-if="field.type=='integer'"  class="form-control" v-model="lead.lead_data[field_index].value"
            />
            <textarea v-if="field.type=='textarea'" class="form-control" v-model="lead.lead_data[field_index].value"></textarea>
            <select    v-if="field.type=='select'" class="form-control"   v-model="lead.lead_data[field_index].value">
              <option v-if="field.options.length>0" v-for="(option2,index2) in field.options"
                      :key="option2" :value="option2"  v-bind:value="option2">{{option2}}</option>
            </select>

            <select  multiple="multiple" v-if="field.type=='multi'" class="form-control" v-model="lead.lead_data[field_index].value">
              <option v-if="field.options.length>0" v-for="(option,index) in field.options"
                      :key="index" :value="option" v-bind:value="option">{{ option}}</option>
            </select>



          </div>
              </sui-card-meta>
          <div class="row">
            <p><button class="btn side4 save_lead_btn" @click="saveLead()">Сохранить изменения</button></p>
          </div>
            </sui-card-content>
          </sui-card>
        </div>

          <div class="col-lg-7">
            <sui-segment>

              <sui-tab :menu="{ pointing: true }">
                <sui-tab-pane title="Все данные " :attached="false">

                  <div class="row"  v-if="all_objects.length>0"   v-for="(lead_object,lead_object_key) in all_objects" :key="lead_object_key">
                    <sui-feed v-if="lead_object.type_object=='history'">

                      <sui-feed-event   >
                        <sui-feed-label>
                          <img :src="image_url+lead_object.user.avatar" />
                        </sui-feed-label>
                        <sui-feed-content>
                          <sui-feed-summary>
                            <sui-feed-user>{{ lead_object.user.name}}</sui-feed-user> {{ lead_object.description}}
                            <sui-feed-date>{{ lead_object.created_at}}</sui-feed-date>
                          </sui-feed-summary>
                          <sui-feed-meta>
                            <sui-feed-like v-if="lead_object.old_value">
                              <sui-icon name="angle left" />
                              было:{{lead_object.old_value}}
                            </sui-feed-like>
                            <sui-feed-like v-if="lead_object.new_value">
                              <sui-icon name="angle right" />
                              стало:{{lead_object.new_value}}
                            </sui-feed-like>
                          </sui-feed-meta>
                        </sui-feed-content>
                      </sui-feed-event>




                    </sui-feed>
                    <sui-comment-group v-if="lead_object.type_object=='comment'" size="massive" threaded>


                      <sui-comment  >
                        <sui-comment-avatar v-if="lead_object.user.avatar" :src="image_url+lead_object.user.avatar"/>
                        <div class="avatar" v-if="lead_object.user.avatar==null">

                          <avatar v-if="lead_object.user.avatar==null" :size="35" :username="lead_object.user.name"
                                  class="rounded-circle"></avatar>

                        </div>


                        <sui-comment-content>
                          <a is="sui-comment-author">{{ lead_object.user.name }}</a>
                          <sui-comment-metadata>
                            <div>{{ lead_object.created_at }}</div>
                            <div v-if="lead_object.is_telegram==1">[сообщение]</div>



                          </sui-comment-metadata>
                          <sui-comment-text>{{ lead_object.comment }}</sui-comment-text>

                        </sui-comment-content>

                      </sui-comment>






                    </sui-comment-group>

                    <sui-comment-group v-if="lead_object.type_object=='task'" size="massive" threaded>


                      <sui-comment  >
                        <sui-comment-avatar v-if="lead_object.create_user.avatar" :src="image_url+lead_object.create_user.avatar"/>
                        <div class="avatar" v-if="lead_object.create_user.avatar==null">

                          <avatar v-if="lead_object.create_user.avatar==null" :size="35" :username="lead_object.create_user.name"
                                  class="rounded-circle"></avatar>

                        </div>


                        <sui-comment-content>
                          <a is="sui-comment-author">{{ lead_object.type.title }}</a>



                          <sui-comment-text>{{ lead_object.text_task }}</sui-comment-text>
                          <sui-comment-metadata>
                            <div>Выполнить до:{{ lead_object.date_to }}</div>
                            <div>Ответственный:{{ lead_object.responsible_user.name }}</div>




                          </sui-comment-metadata>
                          <div class="row alert alert-success" v-if="lead_object.is_complete==1">
                            <div class="col-md-4">
                              {{ lead_object.updated_at}}
                            </div>
                            <div class="col-md-8">
                              {{ lead_object.complete}}
                            </div>
                          </div>
                          <div class="row" v-if="lead_object.is_complete==0">
                            <div class="col-md-4">
                              <button class="mt-lg-5 btn btn-danger" type="button" @click="deleteTask(lead_object.id)">Удалить</button>
                            </div>

                            <div class="col-md-8">
                              <div class="form-group">
                                <label>Введите результат</label>
                                <input type="text" v-model="task_results[lead_object.id]" />

                              </div>

                              <button class="btn btn-success" type="button" @click="setFinishTask(lead_object.id)">Выполнено</button>
                            </div>



                          </div>

                        </sui-comment-content>

                      </sui-comment>






                    </sui-comment-group>

                  </div>



                  <sui-tab :menu="{ pointing: true }">
                    <sui-tab-pane title="Новый комментарий " :attached="false">
                      <sui-comment-group  size="massive" threaded>





                        <h3   is="sui-header" dividing>Написать комментарий</h3>
                        <div class="alert alert-danger" v-if="new_comment_is_error==true">
                          <p>{{ new_comment_error }}</p>
                        </div>


                        <div class="row pt-2 pb-2" >
                          <div class="col-md-8">
                            <label for="exampleTitle">Комментарий </label>
                            <input type="text" class="form-control" required id="exampleTitle" v-model="newComment.comment"
                                   placeholder="Введите комментарий">
                          </div>
                          <div class="col-md-4">


                            <button class=" btn side4 lead_add_comment_btn" v-if="lead.user_id!=null" @click="sendComment">Написать комментарий</button>
                          </div>
                        </div>




                      </sui-comment-group>
                     </sui-tab-pane>
                    <sui-tab-pane v-if="lead.user_id!=null" title="Ответить клиенту " :attached="false">
                      <sui-comment-group  size="massive" threaded>





                        <h3   is="sui-header" dividing>Написать клиенту</h3>
                        <div class="alert alert-danger" v-if="new_comment_is_error==true">
                          <p>{{ new_comment_error }}</p>
                        </div>


                        <div class="row pt-2 pb-2" >
                          <div class="col-md-8">
                            <label for="exampleTitle">Сообщение </label>
                            <input type="text" class="form-control" required id="exampleTitle" v-model="newComment.comment"
                                   placeholder="Введите сообщение">
                          </div>
                          <div class="col-md-4">


                            <button class=" btn side4 lead_add_comment_btn" v-if="lead.user_id!=null" @click="sendCommentTelegram">Ответить клиенту</button>
                          </div>
                        </div>




                      </sui-comment-group>
                    </sui-tab-pane>
                    <sui-tab-pane title="Новая задача " :attached="false">
                      <sui-comment-group  size="massive" threaded>






                        <div class="alert alert-danger" v-if="new_task_is_error==true">
                          <p>{{ new_task_error }}</p>
                        </div>


                        <div class="row pt-2 pb-2" >
                          <div class="col-md-7">
                            <label for="exampleTitle">Текст задачи </label>
                            <input type="text" class="form-control" required id="exampleTitle" v-model="newtask.text"
                                   placeholder="Введите комментарий">

                            <div class="row">
                              <div class="col-md-5">
                                <div class="form-group">
                                  <label>Ответственный</label>
                                  <select class="form-control"   v-model="newtask.responsible_id">
                                    <option v-if="users.length>0" v-for="user in users" :value="user.last_id"
                                            :key="user.last_id">{{
                                        user.name
                                      }}
                                    </option>
                                  </select>
                                </div>

                              </div>
                              <div class="col-md-5">
                                <div class="form-group">
                                  <label>Тип задачи</label>
                                  <select class="form-control" v-model="newtask.type_id" >
                                    <option   v-if="task_types.length>0" v-for="task_type in task_types" :value="task_type.last_id"
                                              :key="task_type.last_id">{{task_type.title}}
                                    </option>
                                  </select>
                                </div>
                              </div>
                            </div>


                          </div>
                          <div class="col-md-4">


                            <div class="form-group">
                              <label>Выполнить до</label>
                              <input type="datetime-local" v-model="newtask.date_to" />

                            </div>

                            <label for="exampleTitle"></label>
                            <button class=" btn side4 lead_add_comment_btn" @click="sendTask">Опубликовать</button>



                          </div>
                        </div>




                      </sui-comment-group>
                    </sui-tab-pane>


                  </sui-tab>





                </sui-tab-pane>

                <sui-tab-pane title="Проекты " :attached="false">
                  <div class="col-lg-12 row row_project_info">
                    <div class="col-lg-6">
                      <sui-card class="card_in_lead">


                        <sui-card-content  class="lead_info">
                          <sui-step-group vertical>
                            <sui-step  >
                              <sui-icon name="user secret" />
                              <sui-step-content>
                                <sui-step-title>Заявка</sui-step-title>
                                <sui-step-description
                                >отредактируйте  <button class="btn side4" @click="callModelEditLead()">заявку</button></sui-step-description
                                >
                              </sui-step-content>
                            </sui-step>

                            <sui-step

                                icon="credit card"
                                title="Требования"
                                description="Уточните детали у клиента"
                            />

                            <sui-step completed>
                              <sui-icon name="info" />
                              <sui-step-content>
                                <sui-step-title>Подтвердите заказ</sui-step-title>
                                <sui-step-description
                                >перейдите по ссылке <a :href="lead.link" target="_blank">{{lead.link}}</a> и начните работать от имени клиента</sui-step-description
                                >
                              </sui-step-content>
                            </sui-step>
                          </sui-step-group>



                        </sui-card-content>
                      </sui-card>
                    </div>
                    <div class="col-lg-6">
                      <sui-card class="card_in_lead">
                        <sui-card-content  class="lead_info">

                          <sui-step-group vertical>
                            <sui-step  >
                              <sui-icon name="user secret" />
                              <sui-step-content>
                                <sui-step-title>Заявка</sui-step-title>
                                <sui-step-description
                                >отредактируйте  <button class="btn side4" @click="callModelEditLead()">заявку</button></sui-step-description
                                >
                              </sui-step-content>
                            </sui-step>

                            <sui-step

                                icon="credit card"
                                title="Требования"
                                description="Уточните детали у клиента"
                            />

                            <sui-step completed>
                              <sui-icon name="info" />
                              <sui-step-content>
                                <sui-step-title>Подтвердите заказ</sui-step-title>
                                <sui-step-description
                                >отправьте ссылку клиенту  <a :href="lead.link" target="_blank">{{lead.link}}</a> и он начнет работать напрямую со специалистами вашей компании</sui-step-description
                                >
                              </sui-step-content>
                            </sui-step>
                          </sui-step-group>


                        </sui-card-content>
                      </sui-card>
                    </div>
                  </div>
                  <div class="col-lg-12" v-if="projects.length>0">

                    <div class="row mt-2"

                         v-for="(project,project_index) in projects" :key="project.last_id">
                      <div class="col-lg-7 text-truncate">
                        <router-link class="text-clip" :to="{name: 'project', params: { id: project.last_id }}">
                          <base-button type="primary" class="text-clip" v-html="project.name_project">


                          </base-button>
                        </router-link>
                      </div>
                      <div class="col-lg-3">

                        <badge pill type="info" v-if="project.status_row.issearch==1">{{ project.status_row.title }}</badge>
                        <badge pill type="warning" v-if="project.status_row.iswork==1">{{ project.status_row.title }}
                        </badge>
                        <badge pill type="success" v-if="project.status_row.isfinish==1">{{ project.status_row.title }}
                        </badge>
                      </div>
                      <div class="col-lg-2">
                        <router-link :to="{name: 'project', params: { id: project.last_id }}"
                                     class="mb-3 mb-sm-0 btn side4">
                          <i
                              class="ni ni-bold-right"></i>
                        </router-link>

                      </div>


                    </div>





                  </div>

                </sui-tab-pane>

              </sui-tab>


            </sui-segment>
          </div>
          <div class="col-lg-2">
            <h2>Виджеты</h2>
            <div class="row widgets_div">

            </div>
          </div>
        </div>


        </div>

      </card>

  </section>

</template>
<script>

import {eventBus} from "@/main";
import axios from 'axios';
import Vue from "vue";
import Api from "../models/Api";
import Modal from "@/components/Modal";
import CircleChart from "@/models/CircleChart";
import vueKanban from 'vue-kanban'
import Editorjsrender from "@/models/Editorjsrender";
import VueTagsInput from '@johmun/vue-tags-input';


export default {
  name: "home",

  data() {

    var app = this;

    return {
      "newtask":{
        "type_id":null,
        "text":null,
        "date_to":null,
        "responsible_id":null,
      },
      "task_results":[],
      "developer_user":null,
      "widgets":[],
      "comments":[],
      "newComment":{},
      "new_comment_is_error":false,
      "new_comment_error":null,
      "new_task_is_error":false,
      "new_task_error":null,
      'projects':[],
      "custom_fields":[],
      "history":[],
      "all_objects":[],
      "task_types":[],
      "image_url":null,
      "user":null,
      "lead":null,
      "islogin":false,
      "is_load":false,
      "statuses": [],
      "users":[],
      "categorys":[],
      tag: '',
      tags: [],


    }
  },
   mounted: function () {

    var app = this;

    let id = app.$route.params.id;

    if (app.$store.getters.ISAUTH) {
      var tmpUser = app.$store.getters.USER;

      app.user = tmpUser;
      app.islogin = true;


    }
    Api.loadLead(id,function(data){
      app.image_url = Vue.config.IMAGE_URL;
      app.widgets=data.widgets;
      if(data.developer_user){
        app.developer_user=data.developer_user;
      }


      app.lead=data.lead;
      app.users=data.users;
      app.all_objects=data.all_objects;

      app.history=data.history;
      app.comments=data.comments;
      app.projects=data.projects;
      app.task_types=data.task_types;
      if(data.lead.tags.length>0){
        var data_tags=data.lead.tags;
        data_tags.forEach((element) => {

          var new_el={"text":element};
          app.tags.push(new_el);
        })
      }

      app.lead.link=Vue.config.BASE_URL+"#/confirm/"+data.lead.secretId;

      if(data.lead.lead_data && data.lead.lead_data.length>0){
        var lead_data=data.lead.lead_data;

        lead_data.forEach((element) => {
          if(element.value){
            app.custom_fields[element.name]={value:element.value};
          }else if(element.type=="multi"){
            app.custom_fields[element.name]={value:[]};
          }else {
            app.custom_fields[element.name]={value:""};
          }
        })

        if(app.widgets.length>0){
          var newlead=data.lead;
          newlead.custom_fields=app.custom_fields;
          window.lead_data=newlead;
          var widgets=app.widgets;
          widgets.forEach((element) => {
            let recaptchaScript = document.createElement('script')
            recaptchaScript.setAttribute('src', element.url_widget+"?v="+Math.random())
            document.head.appendChild(recaptchaScript)
          })

        }


      }
      app.statuses=data.statuses;
      app.categorys=data.categorys;
      app.is_load=true;
    });







  },
  methods: {
    returnBack(){
      var app=this;
      app.$router.push({name: 'funnel', params: {id: app.lead.funnel_id, "rand": Math.random()}});
    },
    changeResponsible(){
      var responsible_id=this.lead.responsible_id;
      var app=this;
      var lead_id=app.lead.id;

      var  json={
        "responsible_id":responsible_id
      };
      app.is_load=false;
      Api.updateLead(json,lead_id,function(data){
        app.is_load=true;
        app.history=data.history;
        app.widgets=data.widgets;
      },function(error){
        alert(error);
      });
    },
    changeStatus(){
      var status_id=this.lead.status_id;
      var app=this;
      var lead_id=app.lead.id;

      var  json={
        "status_id":status_id
      };
      app.is_load=false;
      Api.updateLead(json,lead_id,function(data){
        app.is_load=true;
        app.history=data.history;
        app.widgets=data.widgets;
      },function(error){
        alert(error);
      });
    },
    tagsChanged(newtags){
      var tags=[];
      if(newtags.length>0){
        newtags.forEach((element) => {
          tags.push(element.text);
        });
        this.tags=newtags;

        var app=this;
        var lead_id=app.lead.id;

        var  json={
         "tags":tags
        };
        app.is_load=false;
        Api.updateLead(json,lead_id,function(data){
          app.is_load=true;
          app.history=data.history;
          app.widgets=data.widgets;
        },function(error){
          alert(error);
        });
      }

    },
    setFinishTask(task_id){
      var result="";

      var app=this;
      if(app.task_results[task_id] && app.task_results[task_id].length>0){
        var task_data={};
        task_data.task_id=task_id;
        task_data.result=app.task_results[task_id];
        Api.setFinishTask(task_data, app.lead.id, function (all_objects) {
          document.location.reload();
        },function (message) {

        });
      }


    },
    deleteTask(task_id){
      var app=this;
      Api.deleteLeadTask(task_id, app.lead.id, function (all_objects) {
        document.location.reload();
      },function (message) {

      });
    },
    sendTask(event){
      event.preventDefault();
      var app = this;
      var newtask = app.newtask;
      Api.addLeadTask(newtask, app.lead.id, function (all_objects) {
        document.location.reload();
        app.iserror = false;

        app.newComment.comment = "";
        //app.delete(app.all_objects,[]);
        if(app.all_objects.length>0){
          app.all_objects.forEach(function (item, index, object) {
            object.splice(index, 1);
          });
        }
        app.all_objects=[];
        if(all_objects.length>0){
          all_objects.forEach(function(item){
            app.all_objects.push(item);
          })
        }

        app.all_objects=all_objects;
      }, function (message) {
        app.new_task_is_error = true;
        app.new_task_error= message;
      })
    },
    sendCommentTelegram(event){
      event.preventDefault();
      var app = this;
      var newComment = app.newComment;
      newComment.is_telegram=1;
      Api.addLeadComment(newComment, app.lead.id, function (all_objects) {
        document.location.reload();
        app.iserror = false;

        app.newComment.comment = "";
        //app.delete(app.all_objects,[]);
        if(app.all_objects.length>0){
          app.all_objects.forEach(function (item, index, object) {
            object.splice(index, 1);
          });
        }
        app.all_objects=[];
        if(all_objects.length>0){
          all_objects.forEach(function(item){
            app.all_objects.push(item);
          })
        }

        app.all_objects=all_objects;
      }, function (message) {
        app.iserror = true;
        app.error_message = message;
      })

    },
    sendComment(event) {
      event.preventDefault();
      var app = this;
      var newComment = app.newComment;
      Api.addLeadComment(newComment, app.lead.id, function (all_objects) {
        document.location.reload();
        app.iserror = false;

        app.newComment.comment = "";
        //app.delete(app.all_objects,[]);
        if(app.all_objects.length>0){
          app.all_objects.forEach(function (item, index, object) {
            object.splice(index, 1);
          });
        }
        app.all_objects=[];
        if(all_objects.length>0){
          all_objects.forEach(function(item){
            app.all_objects.push(item);
          })
        }

        app.all_objects=all_objects;
      }, function (message) {
        app.iserror = true;
        app.error_message = message;
      })


    },
    callModelEditLead(){
      var app=this;
      var params = {
        "lead_id": app.lead.id,
        type: "editlead",
        modal_title: "Редактирование лида",
        json:app.lead.project_data
      };
      eventBus.$emit("call_modal_add_project", params)
      {


      }
    },
    saveLead(){
      var app=this;
      var lead_id=app.lead.id;
       var custom_fields=app.lead.lead_data;
    var  json={
      "lead_data":custom_fields,
      "category_id":app.lead.category_id,
      "status_id":app.lead.status_id,
      "tags_text":app.lead.tags_text,
      "responsible_id":app.lead.responsible_id
     }
     if(app.lead.developer_username){
      json["developer_username"]=app.lead.developer_username;
     }
     app.is_load=false;
     Api.updateLead(json,lead_id,function(data){
      app.is_load=true;
       app.history=data.history;
       app.widgets=data.widgets;
     },function(error){
       alert(error);
     });
    }

  },
  components: {Modal,'editorjsrender': Editorjsrender, VueTagsInput,}
};
</script>